import React from 'react'

import './index.css'

const Footer = (props) => (
    <p className="footer">
        {props.children}
    </p>
)

export default Footer